// extracted by mini-css-extract-plugin
module.exports = {"AthelasButton":"AthelasButton_AthelasButton__2p1aj"};